'use strict';
require('../../../modules/es.array.splice');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'splice');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/splice.js
// module id = 566
// module chunks = 13